const state = () => ({
    id: null,
    avatar: null,
    email: null,
    name: null
});

const getters = {
    id: state => state.id,
    avatar: state => state.avatar || '/images/default-user.jpg',
    email: state => state.email,
    name: state => state.name
};

const mutations = {
    setAuthenticationData(state, userData) {
        state.id = userData.id
        state.avatar = userData.avatar
        state.email = userData.email
        state.name = userData.name
    }
};

const actions = {
    authenticate({commit, state}, authenicationEndpoint){
        this._vm.$api.get('/api/user')
            .then(res => commit('setAuthenticationData', res))
            .catch(e => window.location = authenicationEndpoint)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
